import { api } from "./api";

const defaultParams = {
  initForm: true,
};

const defaultBuildParams = {};

export default class reportHandler {
  constructor(uuid) {
    this.uuid = uuid;
  }

  /** get report and extract extras */
  init = async (initParams = {}) => {
    //assign params
    const params = Object.assign(defaultParams, initParams);

    //get report
    if (this.uuid !== 'history') {
      this.report = (await api.q("/report/get", {id: this.uuid})) || {};
      if (this.report.id) {
        //append build form if needed
        if (params.initForm) {
          await this.buildForm();
        }
        return this.report;
      }
    }

    return false;
  };

  buildForm = async (params = {}) => {
    this.form = await api.q("/report/form/build", {
      id: this.uuid,
      params,
    });
  };

  /** preform report build */
  build = async (form = {}, buildParams = {}) => {
    const saveData = {...form};
    const {fields = []} = this.form;

    //assign params
    const params = Object.assign(defaultBuildParams, buildParams);
    params.skipFiles = false;

    const fileFields = fields
      .filter((f) => f.type === "file")
      .map((f) => f.key);

    //if form contains file fields
    if (fileFields.length > 0 && !params.skipFiles) {
      //create a bunch of reader promises and mutate save data
      let fileReaderPromises = {};
      fileFields.forEach((key) => {
        let newSaveDataValue = [];
        if (saveData[key]) {
          let filesArray = Array.from(saveData[key]) || [];
          filesArray.forEach((file, idx) => {
            fileReaderPromises[`${key}~${idx}`] = api.toBase64(file);
            newSaveDataValue[idx] = {
              name: file.name,
              size: file.size,
              date: file.lastModifiedDate,
              text: file.name,
              data: "",
              path: "",
            };
          });
          saveData[key] = newSaveDataValue;
        }
      });

      //mutate save data when all promises are done
      let fileRenderResults = await Promise.allSettled(
        Object.values(fileReaderPromises)
      );

      fileRenderResults.forEach(({value}, idx) => {
        let key = Object.keys(fileReaderPromises)[idx].split("~");
        saveData[key[0]][key[1]].data = value.encoded;
        saveData[key[0]][key[1]].type = value.type;
      });
    }

    //preform build
    this.result = (await api.q("/report/build", {id: this.uuid, form: saveData})) || {};

    if (this.result.id) {
      this.result = await this.extract(this.result.id);
    }

    return this.result;
  };

  extract = async (id) => {
    while (true) {
      let result = await api.q("/report/ready/get", {id: id});
      if (result.statecode === 'progress') {
        console.log('Report is still progress, retrying in 1 second...');
        await new Promise(resolve => setTimeout(resolve, 1000)); // ждём 1 секунду
      } else {
        result.files = await api.q(
          "/object/file",
          {id: id},
          {toArray: true}
        );

        for (const file of result.files) {
          if (file.type === "data:text/html;base64,") {
            let singleFile = await api.q("/object/file/get", {
              id: id,
              name: file.name,
            });

            if (file.name === 'index.html' && singleFile.data) {
              result.html = decodeURIComponent(
                atob(singleFile.data)
                  .split("")
                  .map(function (c) {
                    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                  })
                  .join("")
              );
            }
          }
        }

        return result;
      }
    }
  };
}
